module.exports = __webpack_public_path__ + "09_face.2e7506a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer1/09_face.png
// module id = 26Hp
// module chunks = 0